module.exports = __webpack_public_path__ + "static/images/containers/ShopView/containers/ShopErrorScreen/images/icon-highlight.32acf482.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/containers/ShopErrorScreen/images/icon-highlight.png
// module id = 3261
// module chunks = 11